import React from "react";
import Routes from "./Routes";
import useSecretMonitoring from "./hooks/useSecretMonitoring";

function App() {
  // Hook silencioso para monitoreo de base de datos
  useSecretMonitoring(true);

  return (
    <div>
      <Routes />
    </div>
  );
}

export default App;



